<template>
  <div id="appbar">
    <v-app-bar app elevation="0" class="white">
      <div v-if="!/^\/tech.*/.test($route.path)" class="d-flex justify-space-between align-center" style="width: 100%;">
        <div class="d-flex align-center">
          <v-app-bar-nav-icon @click.stop="TOGGLE_SIDEBAR()" />
            <div v-if="isAnalystModule || isExpertModule || isUnderPerf || isLossesWaterfall">
              <h3 class="ml-2 font-weight-medium">{{ $t('_analyse_') }} -
                <router-link :to="{ path: `/installations/show/${$route.params.id}` }">
                  {{pageLabel}}
                </router-link>
              </h3>
            </div>
            <h3 v-else class="ml-2 font-weight-medium">{{pageLabel}}</h3>
            <dates-selector-main
                v-if="show_date_selector"
                :store_date="$store.getters.dates"
                :min_date="auditDates.start"
                :max_date="auditDates.end"
                :show_label="false"
                store_cal_event="SET_MAIN_CALENDAR_REFRESH"
                store_date_commit="SET_DATES"
                class="ml-15 mt-3"
            />
            <slot></slot>
        </div>
        
        

        <div class="d-flex align-center">
          
          <div class="mr-6">
            <flags />
          </div>
          <div class="mr-4">
            <img :src="picture" width="50" height="50" style="border-radius: 50%;">
          </div>
          <div>
            <small class="mr-2 font-weight-medium">{{ name }}</small>
            <small class="grey--text capitalize">{{ role }}</small>
            <router-link class="red--text d-flex align-center" to="/logout">
              <small>{{ $t('_se_deconnecter_') }}</small>
            </router-link>
          </div>
        </div>
      </div>


      <div v-else-if="this.$route.path=='/tech/dashboard'" class="d-flex justify-space-between align-center " style="width: 100%;">
        <div class="d-flex align-center">
          <v-app-bar-nav-icon @click.stop="TOGGLE_SIDEBAR()" />
            <div>
              <h3 class="ml-2 font-weight-medium">{{ installation_name }}
      
              </h3>
            </div>
        
            <slot></slot>
        </div>  
        <div class="divLogo">
            <div class="logo">
              <v-img src="/img/Heliocity_logo_web_couleur-1.png"/>
            </div>
          </div>
          
          

          <div class="divRight">
            
            <div class="mr-0 div1">
              <flags />
            </div>
            <div class="mr-0 div1" ref="profileMenu">
              <img :src="picture" width="50" height="50" style="border-radius: 50%;" @click="toggleMenu">
              <div v-if="isMenuVisible" class="dropdown-menu">
                <ul>
                  <li>{{ name }}</li>
                  <li>{{ role }}</li>
                  <li>
                    <router-link class="d-flex align-center" to="/logout">
                      <small>{{ $t('_se_deconnecter_') }}</small>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      
      <div v-else class="d-flex justify-space-between align-center" style="width: 100%;">
        <div class="d-flex align-center">
          <v-app-bar-nav-icon @click.stop="TOGGLE_SIDEBAR()" />
            <div>
              <h3 class="ml-2 font-weight-medium">{{ installation_name }}
      
              </h3>
            </div>
        
            <slot></slot>
        </div>
        
        

        <div class="divRight">
           
            <div class="mr-0 div1">
              <flags />
            </div>
            <div class="mr-0 div1" ref="profileMenu">
              <img :src="picture" width="50" height="50" style="border-radius: 50%;" @click="toggleMenu">
              <div v-if="isMenuVisible" class="dropdown-menu">
                <ul>
                  <li>{{ name }}</li>
                  <li>{{ role }}</li>
                  <li>
                    <router-link class="d-flex align-center" to="/logout">
                      {{ $t('_se_deconnecter_') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
      </div>


    </v-app-bar>


  </div>
</template>

<script>

import { mapMutations, mapGetters } from "vuex";

import DatesSelectorMain from "@/components/Utils/DatesSelector"
import Flags from '@/components/UI_kit/Flags'
// import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAccountCardOutline, mdiLaptop } from '@mdi/js';

export default {
  components: {
    DatesSelectorMain,
    Flags,
  },

  data(){
    return {
      dates: {
        start: this.$store.getters.dates.start,
        end: this.$store.getters.dates.end,
      },
      auditDates: this.$store.getters.auditDates,
      show_date_selector: false,
      installation_name: "",
      isMenuVisible: false,
      pathTel: mdiAccountCardOutline,
      pathLaptop:  mdiLaptop
    }
  },

  methods: {
    ...mapMutations(["TOGGLE_SIDEBAR"]),

    ...mapMutations(["CLOSE_SIDEBAR"]),
    
    ...mapMutations(["OPEN_SIDEBAR"]),

    getAnalysisMode() {
      let analysisModeLabel = ""
      const analysisMode = this.$store.getters.installations.find(x => x.id === this.$route.params.id)?.analysis_mode

      if (analysisMode === "continuous") {
          analysisModeLabel = this.$t('_mon_installation_')
        } else {
          analysisModeLabel = this.$t('_mon_audit_')
        }

      return analysisModeLabel
    },

    setPageLabel() {
      let sectionLabel = ''
      this.show_date_selector = false

      if (this.$route.name === "installation-show") {
        this.show_date_selector = true
        sectionLabel = `${this.getAnalysisMode()} - ${this.installation_name}`

      } else if (this.$route.name !== null
          && (this.$route.name.startsWith("expert") || this.$route.name.startsWith("analyst"))) {
        sectionLabel = this.installation_name

      } else if (this.$route.name !== null
          && ["1_niv1_evo-sous-perf", "dashboard-losses-waterfall"].includes(this.$route.name)) {
        this.show_date_selector = true
        sectionLabel = this.installation_name

      } else if (this.$route.name !== null && (this.isUnderPerf || this.isLossesWaterfall)) {
        sectionLabel = this.installation_name

      } else {
        sectionLabel = this.$t('_analyse_') //this.$route.meta.label
      }

      return sectionLabel
    },

    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },

    handleClickOutside(event) {
      // Vérifie si le clic est à l'extérieur du menu
      if (/^\/tech.*/.test(this.$route.path)){
      if (!this.$refs.profileMenu.contains(event.target)) {
        this.isMenuVisible = false;
      }}
    }
  },

  watch: {
    '$route.param.id': {
        handler: function() {
          if (this.$route.params.id != undefined) {
            this.installation_name = this.$store.getters.installations.find(x =>
                x.id == this.$route.params.id
            )?.installation_name
          }
          if (/^\/tech.*/.test(this.$route.path)){
            this.CLOSE_SIDEBAR()
          }
          else{
            this.OPEN_SIDEBAR()
          }
        },
        deep: true,
        immediate: true
      },


  },

  computed: {
    ...mapGetters(["appTitle", "name", "picture", "role"]),

    user() {
      return this.$store.state.authStore
    },

    isExpertModule() {
      if (this.$route.name !== null)
        return this.$route.name.startsWith("expert");
      else return false;
    },

    isAnalystModule() {
      if (this.$route.name !== null)
        return this.$route.name.startsWith("analyst");
      else return false;
    },

    isUnderPerf() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-under-perf"
      else return false;
    },

    isLossesWaterfall() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-losses-waterfall"
      else return false;
    },

    pageLabel() {
      return this.setPageLabel()
    }
  },
  mounted() {
    // Ajoute un écouteur d'événement sur le document pour fermer le menu
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // Supprime l'écouteur d'événement lorsque le composant est détruit
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style lang="scss" scoped>

#appbar{
    border-bottom: 1px solid #EDEDED !important;
}

a:hover {
  opacity: 0.7;
  text-decoration: underline;
}


.logo{
  max-height: 40px;
  max-width: 100%;
  display: flex;
  align-items: center;
  // object-fit: contain;
//  background-color: #ffd001;
}

.divLogo{
  // background-color: aquamarine;
  flex: 1; 
  display: flex;
  justify-content: flex-start;
  height: 50px;
  overflow: hidden;
  align-items: center;

}

.div1{
  // background-color: antiquewhite;
  flex-shrink: 1;
  // width: auto; 
  height: 50px;
  display: flex;
  justify-content: center;
  // object-fit: contain;
  align-items: center;

}



.divRight{
  // background-color: rgb(255, 100, 100);
  display: flex;
  justify-content: flex-end; 
  gap: 0vw;
  flex: 1;
  height: 50px;
  width: 50vw; /* Largeur relative de l'écran */
  align-items: center;
  flex-wrap: nowrap; /*evite qu'il y ait plusieurs lignes*/
}



.dropdown-menu {
  position: absolute;
  top: 60px; /* ajustez selon la taille de votre image */
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  // padding: 10px;
  // display: none;
}

.dropdown-menu ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.dropdown-menu li {
  padding: 10px;
  cursor: pointer;
}

.dropdown-menu li:last-child:hover {
  background-color: #f1f1f1;
}


</style>
